export default __webpack_public_path__ + "static/media/free-200.edccfc1b.png";